import { Outlet, useNavigate, Link, useLocation } from 'react-router'
import { Bell, Code, CreditCard, FileText, LogOut, Plug, User } from 'lucide-react'
import { useUserContext } from '@/context/userLogin'
import { useSidebarStore } from '@/stores/sidebarStore'

export function AccountPage() {
  const { isOpen } = useSidebarStore()
  const { logout } = useUserContext()
  const navigate = useNavigate()
  const location = useLocation()

  const handleLogout = async () => {
    logout()
    if (location.pathname.startsWith('/workspace')) {
      navigate('/')
      window.location.reload()
    }
  }

  const navLinks = [
    {
      label: 'General',
      to: '/account',
      icon: <User className="mr-2 h-4 w-4" />,
    },
    {
      label: 'Notifications',
      to: '/account/notifications',
      icon: <Bell className="mr-2 h-4 w-4" />,
    },
    {
      label: 'Subscriptions',
      to: '/account/subscription',
      icon: <CreditCard className="mr-2 h-4 w-4" />,
    },
    {
      label: 'Legal',
      to: '/account/legal',
      icon: <FileText className="mr-2 h-4 w-4" />,
    },
    {
      label: 'API',
      to: '/account/api',
      icon: <Code className="mr-2 h-4 w-4" />,
    },
    {
      label: 'MCP Connections',
      to: '/account/mcp',
      icon: <Plug className="mr-2 h-4 w-4" />,
    },
  ]

  return (
    <section className="mx-auto mt-[3vh] max-w-6xl flex-1 p-6">
      <div className="mb-4">
        <h1 className="text-foreground text-2xl font-bold">Account</h1>
      </div>

      <div className={`flex flex-col ${isOpen ? 'lg:flex-row' : 'md:flex-row'} gap-6`}>
        <div className="space-y-1 md:w-64">
          <ul className="flex h-auto w-full flex-col space-y-1 bg-transparent p-0">
            {navLinks.map(({ label, to, icon }) => (
              <li key={to}>
                <Link
                  to={to}
                  className={`hover:bg- flex w-full cursor-pointer items-center rounded-md px-2 py-1.5 ${
                    location.pathname === to ? 'bg-hover' : 'hover:bg-hover'
                  }`}>
                  {icon}
                  {label}
                </Link>
              </li>
            ))}

            <li
              onClick={handleLogout}
              className="hover:bg-hover flex w-full cursor-pointer items-center rounded-md px-2 py-1.5 text-red-500">
              <LogOut className="mr-2 h-4 w-4" />
              Sign Out
            </li>
          </ul>
        </div>

        <div className="flex-1">
          <Outlet />
        </div>
      </div>
    </section>
  )
}
